import React from 'react';
import PropTypes from 'prop-types';
import {Typography, Stack, Divider} from '@mui/material';
import {Modal} from '../../../../components/Modal';
import {renderAmount} from '../../../../util';

export function AccumulatedDeficitModal({amount, open, onClose}) {
  if (!amount) {
    return null;
  }

  return (
    <Modal
      keepMounted={false}
      open={open}
      onClose={onClose}
      title="Accumulated Deficit"
    >
      <Divider color="#DFE6E3" />
      <Stack px={3} py={2}>
        <Stack direction="row" justifyContent="space-between">
          <Typography>Net Income (loss)</Typography>
          <Typography>$ {renderAmount(amount)}</Typography>
        </Stack>
        <Typography sx={{color: '#687B7A'}} pt={2}>
          This amount ties directly to the Net income (loss) amount on the
          Income Statement for the period presented.
        </Typography>
      </Stack>
    </Modal>
  );
}

AccumulatedDeficitModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  amount: PropTypes.number.isRequired,
};
